:host {
  display: block;
}
canvas {
  display: none;
}
.view{
  visibility: hidden;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: all 300ms ease-in-out;
  &.visible{
    visibility: visible;
    opacity: 1;
    height: initial;
    overflow: visible;
  }
  .cropper{
    position: relative;
    width: 100%;
    img{
      width: 100%;
      display: block;
      margin: 0 auto;
    }
    .backdrop{
      backdrop-filter: saturate(0.5);
      backdrop-filter: brightness(0.5);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .crop{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      outline: 2px dashed white;
      box-shadow: black 0 0 0px 2px;
      backdrop-filter: saturate(2);
      backdrop-filter: brightness(2);
      cursor: move;
      >div{
        width: 20px;
        height: 20px;
        background-color: white;
        border: 2px solid rgba(0,0,0,0.5);
        position: absolute;
        &.nw, &.ne{
          top: -17px;
        }
        &.ne, &.se{
          right: -17px;
        }
        &.se, &.sw{
          bottom: -17px;
        }
        &.sw, &.nw{
          left: -17px;
        }
        &.nw, &.se{
          cursor: nwse-resize;
        }
        &.ne, &.sw{
          cursor: nesw-resize;
        }
      }
    }
  }
}
dnn-modal{
  --max-width: 512px;
}